module.exports = "/lucky-balls/img/drum/drum_loop_024.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_024.png
// module id = 1039
// module chunks = 0